function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

var x = require('classnames');

_objectDestructuringEmpty(x);

var __esModule = true;
export { __esModule, x as default };